import { ShieldCheck, Building2 } from "lucide-react";
import { companyName, subName } from "../lib/compagnieImport";

// Anteprima dettagliata delle compagnie da importare, con ispettorati e agenzie.
export default function CompagniePreview({ companies }) {
  if (!companies?.length) return null;
  const sorted = [...companies].sort((a, b) => companyName(a).localeCompare(companyName(b), "it", { sensitivity: "base" }));
  return (
    <div className="rounded-lg border border-slate-700 bg-slate-900/40 p-3" data-testid="compagnie-preview-list">
      <p className="text-xs uppercase tracking-wider text-slate-500 font-mono mb-2">Anteprima — {companies.length} compagnie</p>
      <div className="max-h-56 overflow-y-auto space-y-2 pr-1">
        {sorted.map((c, i) => {
          const isp = c.ispettorati || [];
          const age = c.agenzie || [];
          const loc = [c.comune, c.provincia].filter(Boolean).join(" ");
          return (
            <div key={i} className="rounded-md border border-slate-800 bg-slate-900/60 px-3 py-2" data-testid={`preview-compagnia-${i}`}>
              <div className="flex items-center justify-between gap-2">
                <span className="text-sm font-medium text-slate-100 truncate">{companyName(c)}</span>
                <span className="text-[11px] text-slate-500 font-mono shrink-0">
                  {isp.length} isp · {age.length} ag
                </span>
              </div>
              {(c.partita_iva || loc) && (
                <div className="text-[11px] text-slate-500 font-mono">
                  {c.partita_iva ? `P.IVA ${c.partita_iva}` : ""}{c.partita_iva && loc ? " · " : ""}{loc}
                </div>
              )}
              {isp.length > 0 && (
                <div className="mt-1.5 space-y-0.5">
                  {isp.map((x, j) => (
                    <div key={j} className="flex items-center gap-1.5 text-[11px] text-blue-300">
                      <ShieldCheck className="h-3 w-3 shrink-0" />
                      <span className="truncate">{subName(x)}{[x.comune, x.provincia].filter(Boolean).length ? ` — ${[x.comune, x.provincia].filter(Boolean).join(" ")}` : ""}</span>
                    </div>
                  ))}
                </div>
              )}
              {age.length > 0 && (
                <div className="mt-1 space-y-0.5">
                  {age.map((x, j) => (
                    <div key={j} className="flex items-center gap-1.5 text-[11px] text-emerald-300">
                      <Building2 className="h-3 w-3 shrink-0" />
                      <span className="truncate">{subName(x)}{[x.comune, x.provincia].filter(Boolean).length ? ` — ${[x.comune, x.provincia].filter(Boolean).join(" ")}` : ""}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
